<template>
  <div class="[ py-56 max-w-lg m-auto ]">
    <div v-if="loading">
      <p>Loading workspaces</p>
      <ProgressSpinner />
    </div>
    <div v-else>
      <Card>
        <template #content>
          <h1 class="[ text-lg font-bold mb-4 ]">Select a Workspace</h1>

          <div class="[ space-y-3 flex flex-col content-start flex-wrap ]">
            <button
              class="[ px-4 text-lg text-left border rounded-lg p-2 hover:ring-2 focus:ring-blue-500 ]"
              v-for="tenant in clientConfig.tenants"
              @click="selectTenant(tenant.id!)"
            >
              {{ tenant.name }}
            </button>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script setup lang="ts">
import Card from "primevue/card";
import ProgressSpinner from "primevue/progressspinner";
import { useClientConfig } from "@/store/client-config.ts";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

definePage({
  meta: { public: false, title: 'Choose a Workspace' },
});

const clientConfig = useClientConfig();
const router = useRouter();

const loading = ref(true);

onMounted(async () => {
  if (Object.keys(clientConfig.tenants).length < 2) {
    clientConfig.selectedTenant = Object.values(clientConfig.tenants)[0].id!;
    router.replace("/");
    return;
  }
  loading.value = false;
});

function selectTenant(tenantId: number) {
  const shouldReload =
    clientConfig.selectedTenant === -1 ||
    clientConfig.selectedTenant !== tenantId;
  clientConfig.selectedTenant = tenantId;
  if (shouldReload) {
    location.pathname = "/";
  } else {
    router.replace("/");
  }
}
</script>
